export default "__VITE_ASSET__CJUuUiFl__"